import {Component, DestroyRef, inject, Input, OnDestroy} from "@angular/core";
import {DetailsConfig, SharedUiDetailsModule} from '@snelstart/ui-details';
import {ButtonConfiguration, SharedUiButtonModule} from '@snelstart/ui-button';
import {filter, Observable, shareReplay, tap} from "rxjs";
import {AllowanceEntity, BokkzTslDataService, BokkzTslLogic} from "@snelstart-ventures/fiscaal/domain-logic";
import {VoorschotComponent} from '../toeslagen/voorschot/voorschot.component';
import {InkomenComponent} from '../toeslagen/inkomen/inkomen.component';
import {PartnerComponent} from '../toeslagen/partner/partner.component';
import {KinderenComponent} from '../toeslagen/kinderen/kinderen.component';
import {KinderopvangtoeslagComponent} from '../toeslagen/kinderopvangtoeslag/kinderopvangtoeslag.component';
import {HuurtoeslagComponent} from '../toeslagen/huurtoeslag/huurtoeslag.component';
import {BerekeningComponent} from '../toeslagen/berekening/berekening.component';
import {SharedUiDialogModule} from '@snelstart/ui-dialog';
import {TekstAanvragerComponent} from '../toeslagen/toelichtigen-tekst/tekst-aanvrager/tekst-aanvrager.component';
import {TekstPartnerComponent} from '../toeslagen/toelichtigen-tekst/tekst-partner/tekst-partner.component';
import {TekstKinderenComponent} from '../toeslagen/toelichtigen-tekst/tekst-kinderen/tekst-kinderen.component';
import {
  TekstKinderopvangComponent
} from '../toeslagen/toelichtigen-tekst/tekst-kinderopvang/tekst-kinderopvang.component';
import {TekstHuurtoeslagComponent} from '../toeslagen/toelichtigen-tekst/tekst-huurtoeslag/tekst-huurtoeslag.component';
import {CommonModule} from '@angular/common';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-allowance-details',
  templateUrl: './feature-tax-allowance-details.component.html',
  styleUrls: ['./feature-tax-allowance-details.component.scss'],
  imports: [
    SharedUiButtonModule,
    SharedUiDetailsModule,
    InkomenComponent,
    PartnerComponent,
    KinderenComponent,
    KinderopvangtoeslagComponent,
    HuurtoeslagComponent,
    BerekeningComponent,
    SharedUiDialogModule,
    TekstPartnerComponent,
    TekstKinderopvangComponent,
    TekstHuurtoeslagComponent,
    TekstKinderenComponent,
    TekstAanvragerComponent,
    VoorschotComponent,
    CommonModule
  ],
})
export class FeatureTaxAllowanceDetailsComponent implements OnDestroy {

  @Input() public id!: string;
  private readonly destroyRef = inject(DestroyRef);
  private readonly dataService = inject(BokkzTslDataService);
  private readonly bokkzTslLogic = inject(BokkzTslLogic);
  public allowanceEntity = {} as AllowanceEntity;
  public dialogInfoVisible = false;

  public detailsConfig = DetailsConfig.create({
    hideArrowButtons: true,
  });

  readonly allowanceEntity$: Observable<AllowanceEntity> =
    this.dataService.allowanceEntity$.pipe(
      filter((data): data is AllowanceEntity => !!data?.sstRelationId),
      tap(data => {
        this.allowanceEntity = data;
      }),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({ bufferSize: 1, refCount: true })
    );


  ngOnDestroy(): void {
    // No-op: lifecycle cleanup is handled via takeUntilDestroyed.
  }

  public config() {
    return ButtonConfiguration.create({
      onClick: () =>
        new Observable((subscription) => {
          setTimeout(() => {
            subscription.next(true);
            subscription.complete();
            this.bokkzTslLogic.postAllowances(this.allowanceEntity, false);
          }, 200);
        }),
    });
  }

  public showButtonOpslaan(id: string): boolean {
    const toegestaneIds: string[] = ['Berekening'];
    return toegestaneIds.includes(id);
  }

  public showButtonInfo(id: string): boolean {
    const toegestaneIds: string[] = [
      'Aanvrager',
      'Partner',
      'Kinderen',
      'Huurwoning',
      'Kinderopvang',
    ];
    return toegestaneIds.includes(id);
  }

  public showDialogInfo() {
    this.dialogInfoVisible = true;
  }
}
